import React from 'react';
const WhyAgentic = () => {
    return (
        <div
            className="section-py bg-grey dark:bg-black border-b"
            style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <h2 className="text-primary mb-4" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Why Agentic Systems Now?
                        </h2>
                        <p
                            className="text-secondary mb-0 dark:text-[#D7DEE5]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            Modern enterprises are drowning in repetitive workflows, fragmented tools, and slow decisions. Studies reveal that companies lose up to 30% of knowledge worker time on repetitive tasks, costing billions annually. Early adopters of agentic AI report productivity gains three times greater than competitors still grappling with manual bottlenecks. Business teams understand their workflow challenges best, but often lack coding skills to deploy AI agents. Low-code agent builders bridge this gap, enabling deployment speeds 5x faster, from a typical six months down to three to four weeks, and reducing IT backlog by 60% as business users independently configure simple agents.
                        </p>
                    </div>
                    <div className="lg:col-span-6">
                        <p className="mb-0 dark:text-[#D7DEE5]"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Agentic AI transforms operations by integrating safe AI agents into approval loops, customer escalations, and document-heavy processes to provide round-the-clock orchestration and secure automation. Imagine an AI automation system that reviews financial transactions, resolves queries across CRM systems, or curates operational data, all with human-in-loop oversight. Leveraging agent sandbox environments, MCP integrations, and enterprise RPA + AI workflows, organizations can move from manual management to adaptive orchestration that’s traceable, compliant, and future-ready.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default WhyAgentic;
